import PastGrowth from './PastGrowth';

export default PastGrowth;
